import React from 'react';
import { motion } from 'framer-motion';
import {
  homeScrollItem,
  homeScrollStagger,
  homeScrollViewport,
} from '../../utils/homeScrollMotion';
import styles from './ServiceScopeSection.module.css';

const ServiceScopeSection = ({ hue = 'green', body = [], deliverables = [] }) => {
  if (!body.length && !deliverables.length) return null;

  return (
    <section className={styles.scope} data-hue={hue} aria-labelledby="scope-heading">
      <div className={styles.bg} aria-hidden="true">
        <span className={styles.grid} />
      </div>

      <div className={styles.inner}>
        <div className={styles.layout}>
          {body.length > 0 && (
            <motion.div
              className={styles.story}
              variants={homeScrollItem}
              initial="hidden"
              whileInView="visible"
              viewport={homeScrollViewport}
            >
              {body.map((paragraph, index) => (
                <p key={index} className={index === 0 ? styles.lead : undefined}>
                  {paragraph}
                </p>
              ))}
            </motion.div>
          )}

          {deliverables.length > 0 && (
            <motion.div
              className={styles.deck}
              variants={homeScrollItem}
              initial="hidden"
              whileInView="visible"
              viewport={homeScrollViewport}
            >
              <header className={styles.deckHead}>
                <h2 id="scope-heading" className={styles.deckTitle}>
                  What&apos;s included
                </h2>
                <span className={styles.deckLine} aria-hidden="true" />
              </header>

              <motion.div
                className={styles.deckPanel}
                variants={homeScrollStagger}
                initial="hidden"
                whileInView="visible"
                viewport={homeScrollViewport}
              >
                <ul className={styles.itemGrid}>
                  {deliverables.map((item) => (
                    <motion.li key={item.label} className={styles.item} variants={homeScrollItem}>
                      <span className={styles.rowBar} aria-hidden="true" />
                      <span className={styles.rowIcon} aria-hidden="true">
                        {item.icon}
                      </span>
                      <div className={styles.itemBody}>
                        <h3 className={styles.rowTitle}>{item.label}</h3>
                        <p className={styles.rowValue}>{item.value}</p>
                      </div>
                    </motion.li>
                  ))}
                </ul>
              </motion.div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServiceScopeSection;
